import { Component, Input, OnInit, Renderer2 } from '@angular/core';
import { SharedService } from 'src/app/common/services/sharedService';
import { RouteContextProvider } from './../common/services/routeContextProvider.service';
import { CommonConstants } from '../common/utilities/commonConstants';
import { UiStyleToggleService } from '../common/services/ui-style-toggle.service';
@Component({
  selector: 'app-toggle-switch',
  templateUrl: './toggle-switch.component.html',
  styleUrls: ['./toggle-switch.component.scss']
})
export class ToggleSwitchComponent implements OnInit {
  public theme: boolean;
  @Input() showToggle = false;

  constructor(private sharedService: SharedService, private renderer: Renderer2, private _routeContextProvider: RouteContextProvider, private themeService: UiStyleToggleService) { }

  ngOnInit() {
    // const currentTheme = localStorage.getItem('theme');
    // this.theme = currentTheme === 'dark' ? true : false;
    // if (this._routeContextProvider.GetQueryParams('isDark') === '1') {
    //   this.theme = true;
    // } else {
    //   this.theme = false;
    // }
    // this.changeTheme();
    this.setThemeVar();
  }

  changeTheme() {
    this.themeService.toggle();
    this.setThemeVar();
    // this.theme ? localStorage.setItem('theme', 'dark') : localStorage.setItem('theme', 'light');
    // if (this.theme === true) {
    //   this.renderer.addClass(document.body, 'dark');
    // } else {
    //   this.renderer.removeClass(document.body, 'dark');
    // }
    // this.sharedService.themeChange.next(true);
  }
  public googleAnalyticTabOut() {
    let url: any = window.location.pathname;
    url = url.split('/');
    const bflJourney = url.includes(CommonConstants.QueryParamsKeys.marketplace);
    // const bflJourney = true;
    if (bflJourney) {
      const mode = this.theme ? 'Dark Mode' : 'Bright Mode';
      let dataLayer: any = window['dataLayer'];
      dataLayer.push({
        'event': 'mode_change_click',
        'pageType': 'Vehicle Registration Page',
        'mode': mode,
        'productId': 'MGI',
        'productName': 'Motor Insurance'
      });

    }
  }
  setThemeVar() {
    this.theme = this.themeService.isDarkThemeSelected() ? true : false;
  }
}